export const SERVER_POST = 'https://novactiv.ru/post';